// Central brand config — rename here to change the whole site.
export const BRAND = {
  name: "GC Nexon",
  short: "Nexon",
  tagline: "Sell your unused gift cards for instant cash.",
  email: "support@gcnexon.com",
  phone: "1-800-495-8348",
  address: "1013 Centre Rd, Wilmington, DE 19805",
  city: "Wilmington, DE",
  aiName: "NOVA",
  managerName: "David Miller",
  hours: "Mon–Sat, 9AM–8PM ET",
  minCardValue: 50,
  welcomeBonus: 5,
  referralBonusReferrer: 10,
  referralBonusNew: 5,
  payoutMethods: ["PayPal", "Cash App", "Zelle", "Bitcoin", "Chime"],
  social: {
    twitter: "https://twitter.com/",
    facebook: "https://facebook.com/",
    instagram: "https://instagram.com/",
  },
  colors: {
    primary: "#636AC3",
    background: "#FFF6E7",
    accent: "#FFD166",
  },
};
